var websock = null;
var global_callback = {}
var heart = false;
var hearts = false;
var heartBeatTimeOut = null;
var onlineDevice = [];
var sosPrompt = [];
var comingCall = null;
var superSOS = []
var sipSOS = []

let cuIP = window.location.host
let curIP = window.location.hostname

function initWebSocket() { //初始化weosocket
	//ws地址
	var wsuri
	if (curIP == 'localhost' || curIP.indexOf('192.168.') !== -1) {
		// wsuri = "wss://aqm.dqhjkgzb.cn:7443/"; //测试服，第二版
		wsuri = "wss://cap7.runde.pro/wss"; //测试服，第二版
		// wsuri = "wss://znaqm.qianjiangzhilian.com:10006/wss"; //测试服，第二版
	} else {
		wsuri = "wss://" + cuIP + "/wss"; //freeswitch通话
	}

	websock = new WebSocket(wsuri);
	websock.onmessage = function(e) {
		websocketonmessage(e);
	}
	websock.onclose = function(e) {
		websocketclose(e);
	}
	websock.onopen = function() {
		websocketOpen();
	}

	//连接发生错误的回调方法
	websock.onerror = function() {
		console.log("WebSocket连接发生错误");
	}
}

function closeWebSocket() {
	heart = false
	hearts = false
	websock.close()
}

//实际调用的方法
function sendSock(agentData, callback) {
	// ma_group_broadcast-->ma_broadcast 组    状态赋值失败
	// ma_broadcast-->ma_broadcast 全部
	// ma_sending_message-->ma_sending_message 个人

	// xiugaidiao
	if (agentData.act == 'ma_login' && localStorage.getItem('token') != null) {
		agentData.access_token = localStorage.getItem('token')
	}

	global_callback['ma_broadcast'] = callback //组级发送消息初始化
	global_callback[agentData.act] = callback
	if (websock.readyState === websock.OPEN) {
		//若是ws开启状态
		websocketsend(agentData)
	} else if (websock.readyState == 2 || websock.readyState == 3 && (websock.readyState === websock.CONNECTING)) {
		// 若是 正在开启状态，则等待1s后重新调用
		setTimeout(function() {
			sendSock(agentData, callback);
		}, 2 * 1000);
	} else {
		// 若未开启 ，则等待1s后重新调用
		setTimeout(function() {
			sendSock(agentData, callback);
		}, 2 * 1000);
	}
}

// 开始心跳
function startHeartBeat() {
	console.log('socket开始心跳')
	heart = true;
	hearts = true
	heartBeat();
}

// 结束心跳
function stopHeartBeat() {
	console.log('socket结束心跳')
	var self = this;
	heart = false;
	hearts = false
	if (heartBeatTimeOut) {
		clearTimeout(heartBeatTimeOut);
		heartBeatTimeOut = null;
	}
}

// 心跳
function heartBeat() {
	var agentData = {
		"act": "ma_get_active_devices"
	};
	if (!heart) {
		return;
	}
	sendSock(agentData, function(e) {
		// console.log(e)
		if (e.cmd == 'ma_get_active_devices') {
			onlineDevice = e.data ? e.data : []
		}
		if (heart) {
			heartBeatTimeOut = setTimeout(function() {
				heartBeat();
			}, 15 * 1000);
		}
	})
}

//数据接收
var helmetImStatus = null
var uploadPhoto = {}

function initHelmetImStatus() {
	helmetImStatus = null
}

function initUploadPhoto() {
	uploadPhoto = {}
}

function initSosPrompt() {
	sosPrompt = []
}

function initSuperSOS() {
	superSOS = []
}

function initSipSOS() {
	sipSOS = []
}

function websocketonmessage(e) {
	let data = JSON.parse(e.data)

	// data = {
	// 	"cmd": "server_push_sos",
	// 	"data": {
	// 		"user_id": "103737",
	// 		"device_id": "866652021742482",
	// 		"ca_ver": "P2025_RD_M6816_4_64_11.0_V34.0_20250708",
	// 		"mobile": "11111111111",
	// 		"sim": "898608411924",
	// 		"pwd": "123456",
	// 		"c_time": "1729590149",
	// 		"app_last_login_time": "0",
	// 		"ca_last_login_time": "1752551509",
	// 		"user_name": "D6红色帽子",
	// 		"real_name": "D6红色帽子",
	// 		"user_img": "https://mg.runde.pro/public/images/default.jpeg",
	// 		"department": "测试",
	// 		"role": "测试",
	// 		"f_id": "0",
	// 		"cap_type": "2",
	// 		"b1": "",
	// 		"b2": "",
	// 		"sos_height": "10000.00",
	// 		"tk": "2",
	// 		"nearvolt": "2",
	// 		"health": "2",
	// 		"pressure": "2",
	// 		"account_id": "314",
	// 		"w_id": null,
	// 		"acc_list": "314",
	// 		"c_user_id": "314",
	// 		"gas_volt": "0",
	// 		"new_low": "0",
	// 		"uwb_device_id": "",
	// 		"rtmp_open": "0",
	// 		"voice_pkg": null,
	// 		"fb_id": null,
	// 		"min_o2": "19.5",
	// 		"max_o2": "23.5",
	// 		"watch": "",
	// 		"local_record": "1",
	// 		"last_count_online_time": "1752551706",
	// 		"watch_mac": "56:33:21:66:BF:01",
	// 		"co": "10.0",
	// 		"app_version": "M6816_5G_GZRQ_70_gas_rtk",
	// 		"min_temp": "0.00",
	// 		"max_temp": "0.00",
	// 		"max_heartbeat": "0",
	// 		"min_heartbeat": "0",
	// 		"shrink": "0",
	// 		"diastolic": "0",
	// 		"video_pre": null,
	// 		"push_sos_url": null,
	// 		"electrostatic": "6",
	// 		"headset": "",
	// 		"upload_video_num": "56",
	// 		"notuploaded_video_count": "0",
	// 		"privacy_switch": "0",
	// 		"boot_broadcast": "0",
	// 		"gas_mac": "",
	// 		"check_upgrade": null,
	// 		"new_app_id": null,
	// 		"check_system_upgrade": null,
	// 		"new_system_app_id": null,
	// 		"floor": "0",
	// 		"bt_strength": "0",
	// 		"bt_scanner": null,
	// 		"nh3": null,
	// 		"h2s": null,
	// 		"video_call_type": "3",
	// 		"ca_report_time": "0",
	// 		"ch4": null,
	// 		"hook_mac": "",
	// 		"room_id": "",
	// 		"gas_collection": "{\"ch4\":0,\"co2\":0,\"h2s\":0,\"nh3\":0,\"so2\":0,\"voc\":0,\"ph3\":0,\"no2\":0,\"o3\":0,\"cl2\":0,\"hcl\":0,\"hf\":0,\"ch2o\":0,\"sf6\":0,\"no\":0,\"h2\":0}",
	// 		"video_size": null,
	// 		"wifi_info": null,
	// 		"location": "",
	// 		"month_used_video_size": "1525534718",
	// 		"month_max_video_size": "20971520",
	// 		"obstacle_distance_up": "",
	// 		"obstacle_distance_rear": "",
	// 		"sipphone": "0",
	// 		"mz_call": "0",
	// 		"light_value": "0",
	// 		"auto_change_quality": "0",
	// 		"last_rail_status": "0"
	// 	},
	// 	"x_point": "0.0",
	// 	"y_point": "0.0",
	// 	"sos_type": "4",
	// 	"time": 1752551940,
	// 	"msg": "",
	// 	"RequestID": "98d40f7d-4044-4ea6-a46e-b8b9fc1ddef1"
	// }

	if (data.cmd == 'server_push_sos') {
		//帽子已移除该功能
		// console.log(data)



		if (data.data.device_id == '866652021742482') {
			sosPrompt.push(data)
		}

	} else if (data.cmd == 'server_push_ca_call_manager') {
		//帽子已移除该功能
		// console.log(data)
		comingCall = data
	} else if (data.cmd == 'server_push_ca_super_sos') {
		//报警和通话合在一起
		// console.log(data)
		superSOS.push(data)
	} else if (data.cmd == 'server_push_ca_report_error') {
		//帽子IM登录成功与否
		// console.log(data)
		helmetImStatus = data
	} else if (data.cmd == 'server_push_ca_upload_photo') {
		//是否有图片上传
		// console.log(data)
		uploadPhoto = data
	} else if (data.cmd == 'server_push_ca_sip_sos' || data.cmd == 'server_push_ca_sip_room' || data.cmd ==
		'server_push_ca_broadcast') {
		//sip通话
		// console.log(data)
		sipSOS.push(data)
	} else {
		global_callback[data.cmd](data)
	}
}

//数据发送
function websocketsend(agentData) {
	websock.send(JSON.stringify(agentData));
}

//关闭
var isWillingWithdraw = false
var isAbnormalInterruption = false

function restore() {
	isWillingWithdraw = false
	isAbnormalInterruption = false
}

function doWillingWithdraw() {
	isWillingWithdraw = true
}

function websocketclose(e) {
	console.log("connection closed (" + e.code + ")");
	if (!isWillingWithdraw) {
		heart = false
		hearts = false
		isAbnormalInterruption = true
	}
}

function websocketOpen(e) {
	hearts = true
	console.log("连接成功");
}

export {
	websock,
	sendSock,
	closeWebSocket,
	onlineDevice,
	sosPrompt,
	initSosPrompt,
	comingCall,
	superSOS,
	sipSOS,
	initSuperSOS,
	initSipSOS,
	startHeartBeat,
	stopHeartBeat,
	heart,
	hearts,
	isWillingWithdraw,
	isAbnormalInterruption,
	restore,
	doWillingWithdraw,
	initWebSocket,
	helmetImStatus,
	initHelmetImStatus,
	uploadPhoto,
	initUploadPhoto
}